import { render, staticRenderFns } from "./YoutubeClaims.vue?vue&type=template&id=6352f90a"
import script from "./YoutubeClaims.vue?vue&type=script&lang=js"
export * from "./YoutubeClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports